module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.3e1af3ef.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Regular.ttf
// module id = 552
// module chunks = 9